/**
 * VillaMax — Modal de fórmula médica / refrigerado al agregar al carrito
 *
 * Ataja el envío del formulario de producto (Dawn: product-form manda
 * FormData(form) a /cart/add) cuando la ficha trae rx-cold-modal.liquid:
 *
 * - Fórmula médica: casilla "tengo la fórmula" (obligatoria); archivo y datos
 *   del médico opcionales.
 * - Refrigerado: casilla de que no tiene devolución.
 *
 * Lo aceptado viaja como propiedades de la línea (properties[...]); el archivo
 * se asocia al formulario con el atributo form, así Shopify lo sube con el
 * resto. Los datos del médico se recuerdan en la sesión para el siguiente
 * producto con fórmula.
 * No usa template literals por compatibilidad con el editor de Shopify.
 */
(function () {
  "use strict";

  var MODAL_ID = "vx-rx-modal";
  var SESSION_KEY = "vx_rx_doctor";
  var MAX_BYTES = 5 * 1024 * 1024;
  var ALLOWED = /\.(png|jpe?g|pdf)$/i;
  var pendingForm = null;
  var confirmedForm = null;
  var added = [];

  function modal() {
    return document.getElementById(MODAL_ID);
  }

  function isTrue(el, attr) {
    return el.getAttribute(attr) === "true";
  }

  function isAddForm(form) {
    return form && form.tagName === "FORM" && /\/cart\/add/.test(form.getAttribute("action") || "");
  }

  function showError(m, text) {
    var box = m.querySelector("[data-vx-error]");
    box.textContent = text;
    box.hidden = !text;
  }

  function loadDoctor(m) {
    var saved = {};
    try {
      saved = JSON.parse(sessionStorage.getItem(SESSION_KEY) || "{}");
    } catch (e) {}
    m.querySelectorAll("[data-vx-prop]").forEach(function (input) {
      if (!input.value && saved[input.getAttribute("data-vx-prop")]) {
        input.value = saved[input.getAttribute("data-vx-prop")];
      }
    });
  }

  function saveDoctor(m) {
    var data = {};
    m.querySelectorAll("[data-vx-prop]").forEach(function (input) {
      data[input.getAttribute("data-vx-prop")] = input.value.trim();
    });
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function open(m, form) {
    pendingForm = form;
    showError(m, "");
    loadDoctor(m);
    m.hidden = false;
    document.documentElement.style.overflow = "hidden";
    var first = m.querySelector("input");
    if (first) first.focus();
  }

  function close(m) {
    m.hidden = true;
    pendingForm = null;
    document.documentElement.style.overflow = "";
  }

  function hidden(form, name, value) {
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = "properties[" + name + "]";
    input.value = value;
    input.setAttribute("data-vx-added", "");
    form.appendChild(input);
    added.push(input);
  }

  function clearAdded() {
    added.forEach(function (input) {
      if (input.parentNode) input.parentNode.removeChild(input);
    });
    added = [];
  }

  /** Devuelve el error a mostrar, o "" si se puede agregar. */
  function validate(m) {
    if (isTrue(m, "data-rx")) {
      var file = m.querySelector("[data-vx-rx-file]");
      if (!m.querySelector("[data-vx-rx-accept]").checked) {
        return "Marca la casilla de que tienes la fórmula médica.";
      }
      // Médico, institución, registro y archivo son opcionales.
      var chosen = file && file.files && file.files[0];
      if (chosen && !ALLOWED.test(chosen.name)) {
        return "La fórmula debe ser png, jpg o pdf.";
      }
      if (chosen && chosen.size > MAX_BYTES) {
        return "La fórmula pesa más de 5 MB. Toma una foto más liviana o escribe el nombre del médico.";
      }
    }
    if (isTrue(m, "data-cold") && !m.querySelector("[data-vx-cold-accept]").checked) {
      return "Confirma que el producto refrigerado no tiene devolución.";
    }
    return "";
  }

  function confirm(m) {
    var form = pendingForm;
    var error = validate(m);
    if (error) {
      showError(m, error);
      return;
    }
    clearAdded();

    if (isTrue(m, "data-rx")) {
      hidden(form, "Fórmula médica", "El cliente declara tenerla");
      m.querySelectorAll("[data-vx-prop]").forEach(function (input) {
        if (input.value.trim()) hidden(form, input.getAttribute("data-vx-prop"), input.value.trim());
      });
      saveDoctor(m);
      var file = m.querySelector("[data-vx-rx-file]");
      if (form.id) {
        file.setAttribute("form", form.id);
      }
      if (!file.files || !file.files[0]) {
        file.removeAttribute("form");
      }
    }
    if (isTrue(m, "data-cold")) {
      hidden(form, "Refrigerado", "Aceptó que no tiene devolución");
    }

    close(m);
    confirmedForm = form;
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
    }
  }

  // Captura en document: corre antes que el listener de product-form.
  document.addEventListener(
    "submit",
    function (event) {
      var m = modal();
      var form = event.target;
      if (!m || !isAddForm(form)) return;
      if (confirmedForm === form) {
        confirmedForm = null;
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      open(m, form);
    },
    true
  );

  document.addEventListener("click", function (event) {
    var m = modal();
    if (!m || m.hidden) return;
    if (event.target.closest("[data-vx-close]")) {
      close(m);
    } else if (event.target.closest("[data-vx-confirm]")) {
      confirm(m);
    }
  });

  document.addEventListener("keydown", function (event) {
    var m = modal();
    if (m && !m.hidden && event.key === "Escape") close(m);
  });
})();
